import { common } from './common'
import { owner } from './owner'
import { platform } from './platform'

/**
 * The console dictionary, assembled from three parts so each console owns its
 * own file. Split three ways rather than one flat object because a console
 * string has no business in the phone bundle, and because two people editing
 * two consoles should not be editing the same file.
 */
export const messages = { ...common, ...platform, ...owner }

export type ConsoleMessageKey =
  | keyof typeof common
  | keyof typeof platform
  | keyof typeof owner
